import { useState } from "react";
import { hotComments } from "@/mocks/guaData";
import type { Comment } from "@/mocks/guaData";

const toneBg: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function CommentsShowcase() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  return (
    <section id="comment" className="py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <span className="inline-block h-4 w-1 rounded-full bg-primary-500"></span>
            评论区精选
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            点开就能看到大家怎么看
          </h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            来自吃瓜现场的精彩发言，热评前排已被机智网友占领。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {hotComments.map((c) => (
            <article key={c.id} className="flex flex-col justify-between rounded-xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-0.5 hover:border-accent-200">
              <div>
                <span className={`whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium ${toneBg[c.tone]}`}>{c.tag}</span>
                <blockquote className="mt-3 text-[15px] leading-relaxed text-foreground-800">
                  “{c.text}”
                </blockquote>
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                <div className="flex items-center gap-2.5">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-sm ${toneBg[c.tone]}`}>{c.initial}</span>
                  <div className="leading-tight">
                    <p className="text-sm font-medium text-foreground-900">{c.name}</p>
                    <p className="text-xs text-foreground-500">{c.time}</p>
                  </div>
                </div>
                <button
                  onClick={() => setLiked((p) => ({ ...p, [c.id]: !p[c.id] }))}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition ${
                    liked[c.id]
                      ? "border-primary-300 bg-primary-50 text-primary-700"
                      : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                  }`}
                  aria-pressed={!!liked[c.id]}
                >
                  <i className={liked[c.id] ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                  {c.likes + (liked[c.id] ? 1 : 0)}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}